import { configureStore } from "@reduxjs/toolkit";
import { EditorsServiceBuilder } from "./EditorsService";
import { ProjectServiceBuilder } from './ProjectService';
import { ResourceTreeServiceBuilder } from "./ResourceTreeService";
import { WorkspaceServiceBuilder } from "./WorkspaceService";
import { reducer } from "./reducer";
import { ChangeServiceBuilder } from "./ChangeService";
import { DialogServiceBuilder } from "./DialogService";
import { NotificationsServiceBuilder } from "./NotificationsService";
// A utility function for tests and stories to simplify initial state description
export const getInitialState = () => configureStore({ reducer }).getState();
const createServiceAPIs = (runtime) => {
    const DialogService = DialogServiceBuilder.api(runtime);
    const NotificationsService = NotificationsServiceBuilder.api(runtime);
    const ProjectService = ProjectServiceBuilder.api(runtime);
    const ChangeService = ChangeServiceBuilder.api({ ...runtime, DialogService, NotificationsService, ProjectService });
    const EditorsService = EditorsServiceBuilder.api({ ...runtime, ProjectService });
    const ResourceTreeService = ResourceTreeServiceBuilder.api({ ...runtime, ProjectService });
    const WorkspaceService = WorkspaceServiceBuilder.api({ ...runtime, ChangeService, EditorsService, ResourceTreeService });
    return {
        ...runtime,
        ChangeService,
        EditorsService,
        DialogService,
        NotificationsService,
        ProjectService,
        ResourceTreeService,
        WorkspaceService,
    };
};
const createLoggingMiddleware = (log) => (store) => (next) => (action) => {
    log && console.log('Dispatching', action);
    const result = next(action);
    log && console.log(`State`, store.getState());
    return result;
};
export const createServiceLayer = ({ platformAPI, initialState, log, }) => {
    const store = configureStore({
        reducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware()
            .concat(createLoggingMiddleware(log)),
    });
    log && console.log('Intial store state', store.getState());
    const serviceAPIs = createServiceAPIs({ platformAPI, store });
    return {
        store,
        serviceAPIs,
    };
};
//# sourceMappingURL=index.js.map